module.exports = __webpack_public_path__ + "/templates/pages/girolibero-links.twig";